var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfo2 = function SvgInfo2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "0 0 50 50",
    width: "24px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    style: {
      fill: "none",
      strokeWidth: 3,
      stroke: "#000"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: "24px",
    width: "24px",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 16.2c-0.2 0-0.4-0.1-0.4-0.4v-2.6c0-0.2 0.1-0.4 0.4-0.4h2.4c0.2 0 0.4 0.1 0.4 0.4v2.6c0 0.2-0.1 0.4-0.4 0.4H23.8zM23.9 37.3c-0.2 0-0.4-0.1-0.4-0.4V20.5c0-0.2 0.1-0.4 0.4-0.4h2.3c0.2 0 0.4 0.1 0.4 0.4v16.5c0 0.2-0.1 0.4-0.4 0.4H23.9z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info2.67a52e58.svg";
export { ForwardRef as ReactComponent };